export namespace IConstants {

    export const CONSTANT_AUTH_STORAGE_NAME: string = "auth";

    export const CONSTANT_LANGUAGE_STORAGE_NAME: string = "language";

    export const CONSTANT_OFFLINE_MODE_STORAGE_NAME: string = "offline-mode";

    export const CONSTANT_AUTO_SYNC_STORAGE_NAME: string = "auto-sync";
}